module.exports = __webpack_public_path__ + "img/4@3x.b438caec.png";